import toastr from 'toastr';
import { MFChannel } from '../../../Components/SDK';
import { getAppOnlineStatus, setActionStatus } from '../../../Slice';
import Store from '../../../Store';
import { resetActionModal } from '../actionModalUtils';
import { NO_INTERNET } from '../constants';
import { showErrorToast, showInfoToast, showNetworkErrorToast, showSucessToast } from '../toast';
import { CHANNEL_CATEGORY_LIST } from '../../../Actions/Constants';
import { REACT_APP_CHANNEL_API_URL } from '../../../Components/processENV';
import { getFromLocalStorageAndDecrypt } from '../../../Components/WebChat/WebChatEncryptDecrypt';

export const canPinMoreChannels = channelId => {
   const entities = Store.getState()?.recentChannelListData?.channels?.entities || {};
   const isAlreadyPinned = Boolean(entities?.[channelId]?.pinnedAt && entities?.[channelId]?.pinnedAt > 0);
   if (isAlreadyPinned) return true;
   const pinnedCount = Object.values(entities).reduce(
      (count, ch) => (ch?.pinnedAt && ch.pinnedAt > 0 ? count + 1 : count),
      0,
   );
   return pinnedCount < 3;
};

export const handleMuteChannel = async ({ channelId, action }) => {
   if (!getAppOnlineStatus()) return toastr.error(NO_INTERNET);
   try {
      const response = await MFChannel.muteChannel({ channelIds: [channelId], action });
      if (response?.statusCode === 200) {
         Store.dispatch(setActionStatus({ isMuted: action ? 1 : 0, channelIds: [channelId] }));
         showInfoToast(response?.message);
      } else if (response?.statusCode === 208) {
         showInfoToast(response?.message || 'Something went wrong. Please try again later');
      } else {
         showErrorToast(response?.message || 'Something went wrong. Please try again later');
      }
   } catch (error) {
      console.error('Failed to mute/unmute the channel', error);
   }
};

export const handlePinChannel = async ({ channelId, action }) => {
   if (!getAppOnlineStatus()) return toastr.error(NO_INTERNET);
   try {
      if (action === 1 && !canPinMoreChannels(channelId)) return showErrorToast('You can only pin up to 3 channels');

      const response = await MFChannel.pinChannel({ channelIds: [channelId], action });

      if (response?.statusCode === 200) {
         showInfoToast(response?.message);
      } else if (response?.statusCode === 208) {
         showInfoToast(response?.message || 'Something went wrong. Please try again later');
      } else {
         showErrorToast(response?.message || 'Something went wrong. Please try again later');
      }
   } catch (error) {
      console.error('Failed to pin/unpin the channel', error);
   }
};

export const handleUpdateSettings = async ({ channelId, settings }) => {
   try {
      if (!getAppOnlineStatus()) return showNetworkErrorToast();
      const res = await MFChannel.updateChannelSettings({ channelId, settings });
      if (res.statusCode !== 200) {
         showErrorToast(res?.message);
      } else {
         showSucessToast(res?.message);
      }
   } catch (error) {
   }
};

export const handleChannelAction = async (channelId, actionType) => {
   if (!getAppOnlineStatus()) return toastr.error(NO_INTERNET);
   try {
      let res;
      if (actionType === 'leave') {
         res = await MFChannel.leaveChannel({ channelId });
      } else if (actionType === 'delete') {
         res = await MFChannel.deleteChannel({ channelId });
      } else if (actionType === 'non member delete') {
         res = await MFChannel.deleteRecentChannel({ channelIds: [channelId] });
      } else {
         console.warn(`Unsupported channel action type: ${actionType}`);
         return;
      }
      const { statusCode, message } = res;
      if (statusCode === 200) {
         const successMsg =
            actionType === 'leave' ? 'You have left the channel successfully' : 'Channel has been deleted successfully';

         toastr.success(successMsg);
         resetActionModal();
      } else {
         toastr.error(message || `Failed to ${actionType} the channel`);
      }
   } catch (error) {
      console.error(`Error during ${actionType} channel:`, error);
   }
};

export const handleChannelMemberAction = async ({ channelId, userId, action }) => {
   if (!getAppOnlineStatus()) return toastr.error(NO_INTERNET);
   try {
      let res = {};
      let successMessage = '';
      let errorMessage = 'Failed to update channel member action';
      switch (action) {
         case 'makeAdmin':
            res = await MFChannel.makeAsAdmin({ channelId, userId });
            successMessage = 'Make Admin Successfully';
            break;

         case 'removeAdmin':
            res = await MFChannel.revokeAdmin({ channelId, userId });
            successMessage = 'Removed Admin Successfully';
            break;

         case 'removeMember':
            res = await MFChannel.removeMembers({ channelId, userIds: [userId] });
            successMessage = 'Removed member successfully';
            break;

         default:
            console.warn(`Unsupported channel member action type: ${action}`);
            return;
      }
      const { statusCode, message } = res;
      if (statusCode === 200) {
         toastr.success(successMessage || message || 'Channel member action updated successfully');
      } else {
         toastr.error(message || errorMessage);
      }
   } catch (error) {
      console.error('Error updating channel member:', error);
      toastr.error('Something went wrong while updating channel member');
   }
};

export const handleChannelStatusAction = async ({ channelId, active }) => {
   if (!getAppOnlineStatus()) return toastr.error(NO_INTERNET);
   try {
      const res = await MFChannel.updateChannelStatus({ channelId, active });
      const { statusCode, message } = res;
      if (statusCode === 200) {
         const successMsg = active ? 'Channel activated successfully' : 'Channel deactivated successfully';
         toastr.success(successMsg);
      } else {
         toastr.error(message || 'Failed to update channel status');
      }
   } catch (error) {
      console.error('Error updating channel status:', error);
      toastr.error('Something went wrong while updating channel status');
   }
};

export const handleChannelUpdate = async ({ channelId, params }) => {
   try {
      
      const isOnline = getAppOnlineStatus();
      if (!isOnline) return showNetworkErrorToast();
      const res = await MFChannel.updateChannel({ channelId, params });
      if (res.statusCode !== 200) {
         showErrorToast(res?.message);
      } else {
         showSucessToast(res?.message);
      }
   } catch (error) {
   }
};


export const setChannelCategoryList = (categories) => ({
    type: CHANNEL_CATEGORY_LIST,
    payload: categories,
});

const fetchChannelGetCategory = (token) => {
    return fetch(`${REACT_APP_CHANNEL_API_URL}/channel/getCategory`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
    .then(res => res.json())
    .then(data => {
        if (data?.success && Array.isArray(data.data)) {
            return data.data;
        }
        return [];
    })
    .catch((error) => {
        return [];
    });
};

export const fetchAndStoreChannelCategories = (token) => async (dispatch) => {
    const categories = await fetchChannelGetCategory(token);
    dispatch(setChannelCategoryList(categories));
};


export const handleMarkAsUnread = async ({ channelId }) => {
   try {
      const res = await MFChannel.makeAsUnread({ channelId });
      if (res.statusCode === 200) {
         showSucessToast('Channel marked as unread');
      } else {
         showErrorToast(res?.message);
      }
   } catch (error) {
      console.error('Failed to mark channel as unread', error);
      showErrorToast(error?.message);
   }
};

export const handleMarkAsRead = async ({ channelId, messageId = '', isOnPress = false }) => {
   try {
      if (!getAppOnlineStatus() && isOnPress) return showNetworkErrorToast();
      const res = await MFChannel.markMessageAsRead({ channelId, messageId });
      if (isOnPress) {
         if (res.statusCode !== 200) {
            showErrorToast(res?.message);
         } else {
            showSucessToast('Channel marked as read');
         }
      }
   } catch (error) {
      console.error('Failed to mark channel as unread', error);
      showErrorToast('Failed to mark channel as read');
   }
};

export const setTabActiveStatus = (index) => ({
  type: 'SET_MENU_ACTIVE_STATUS',
  payload: index
});